<!-- eslint-disable vue/multi-word-component-names -->
<script>
import Filtro05 from '@/components/shared/relatorio/filtros/Filtro05.vue'

export default {
  extends: Filtro05,

  methods: {
    carregarListaEntidades() {
      this.entidadeService.getListaEntidades().then((res) => {
        this.entidades = res
      })
    },

    carregarConsignataria() {
      this.consignatariasSelecionadas.push(
        JSON.parse(localStorage.getItem('consignatariaSelecionada')),
      )
      this.adicionarConsignataria()
      this.exibirListaConsignataria = false
    },
  },
}
</script>
